export const userErrorMessages = {
  wrong_old_password: 'users.wrong_old_password',
};
